export const FULL_INGESTION_LOG_NAME = 'Full Ingestion';

export const INGESTION_ERROR_TEXT = {
  default: 'There was an error running this ingestion.',
};

export interface IOnAddDismissibleLinkProp {
  onAddDismissibleLink: () => void;
}
